// extracted by mini-css-extract-plugin
export var capacity = "ProductSideBySide-module--capacity--2b9c6";
export var content = "ProductSideBySide-module--content--62a3f";
export var description = "ProductSideBySide-module--description--96369";
export var dots = "ProductSideBySide-module--dots--89e49";
export var gallery = "ProductSideBySide-module--gallery--2bdf6";
export var galleryProducts = "ProductSideBySide-module--galleryProducts--e0d58";
export var galleryWrapper = "ProductSideBySide-module--galleryWrapper--fc3b8";
export var nextArrowButton = "ProductSideBySide-module--nextArrowButton--81786";
export var prevArrowButton = "ProductSideBySide-module--prevArrowButton--1fb8a";
export var productCard = "ProductSideBySide-module--productCard--9469b";
export var productImage = "ProductSideBySide-module--productImage--cf131";
export var productName = "ProductSideBySide-module--productName--b7262";
export var siteUrl = "ProductSideBySide-module--siteUrl--7f95a";
export var wrapper = "ProductSideBySide-module--wrapper--ee6c3";